import { render, staticRenderFns } from "./Untrading.vue?vue&type=template&id=74bc970a&"
import script from "./Untrading.vue?vue&type=script&lang=js&"
export * from "./Untrading.vue?vue&type=script&lang=js&"
import style0 from "./Untrading.vue?vue&type=style&index=0&id=74bc970a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports